/* eslint-disable guard-for-in */
var ezdia;
(function (ezdia) {
    var containerSuffix = 'ez-import-step-fields-container-';
    var classes = {
        warning: 'bg-warning',
        danger: 'bg-danger',
        success: 'bg-success',
        dangerText: 'text-danger'
    };
    var pageParams = null;
    var mappendFields = [];
    var roleChange = function () {
        $('#ez-role').change(function change() {
            var params = "importDTO.role=" + this.value;
            params += "&importDTO.accountName=" + pageParams.account;
            window.location.href = "ImportData.htm?" + params;
        });
    };
    var accountChange = function () {
        var elem = $('#ez-accountName');
        elem
            .sortItems()
            .val(pageParams.account)
            .change(function change() {
            var params = "importDTO.accountName=" + this.value + "&importDTO.role=" + $('#ez-role').val();
            window.location.href = "ImportData.htm?" + params;
        });
        elem.sortItems().chosen({
            placeholder_text: '',
            disable_search_threshold: 10
        });
        setTimeout(function () {
            var widths = elem.outerWidth();
            $('#ez_accountName_chosen').css('width', widths);
        }, 0);
    };
    var steps = function (count) {
        var elem = $("#ez-steps-" + count);
        var title = elem.data('stepTitle');
        var prev = elem.prev();
        var prevstep = prev.data('step');
        var prevtitle = prev.data('stepTitle');
        elem
            .removeClass('step-done')
            .addClass('step-active')
            .siblings()
            .removeClass('step-active')
            .end()
            .prevAll()
            .addClass('step-done');
        $('#ez-task-current-step').html("Step " + count + ": " + title);
        if (count > 1) {
            $('#ez-back-link').attr('data-original-title', "Back to Step " + prevstep + ": " + prevtitle);
        }
        else {
            pageParams = $.ezdia.config.pageParams;
            if (pageParams.genericImport && pageParams.genericImport === true) {
                $('#ez-back-link')
                    .attr('data-original-title', 'Back to Project Management')
                    .off('click')
                    .on('click', function () {
                    window.location = $.ezdia.config.pageParams.CONTEXT_ROOT + "/desk/ShowStoreForm.htm?formtype=" + pageParams.formtype;
                });
            }
            else {
                $('#ez-back-link')
                    .attr('data-original-title', 'Back to My Dashboard')
                    .off('click')
                    .on('click', function () {
                    window.location = $.ezdia.config.pageParams.CONTEXT_ROOT + "/desk/Home.htm";
                });
            }
        }
        $('div[data-step-container="container"]').hide();
        $("#" + containerSuffix + count).show();
    };
    var loadUploadBtn = function (btn) {
        btn.button('loading');
        $.ajax({
            type: 'POST',
            url: 'ImportActions.htm',
            data: "importDTO.accountName=" + pageParams.account + "&importDTO.role=" + pageParams.role + "&formtype=" + pageParams.formtype + "&genericImport=" + pageParams.genericImport + "&userManagement=" + pageParams.userManagement,
            dataType: 'text',
            success: function (data) {
                btn.button('reset');
                loadUploadBtnSuccess(data);
            },
            error: function (data) {
                btn.button('reset');
                $('#uploadactions').html(data);
            }
        });
    };
    function goToStepTwo() {
        var btn = $(this);
        $('#message').hide();
        steps(2);
        loadUploadBtn(btn);
        $('#ez-back-link')
            .off('click')
            .on('click', function () {
            steps(1);
        });
    }
    function goToStepThree(data) {
        var elem = $('#message');
        elem.hide();
        $("#" + containerSuffix + 3).html(data);
        if (pageParams.idColumn === false &&
            pageParams.message &&
            pageParams.editType === 'update') {
            elem.show().html(pageParams.message).addClass('alert-warning');
            steps(2);
            var btn = $(this);
            loadUploadBtn(btn);
            $('#ez-back-link')
                .off('click')
                .on('click', function () {
                $('#message').hide();
                steps(1);
            });
        }
        else if (pageParams.redirectToCreateImportView &&
            pageParams.redirectToCreateImportView === true) {
            goToStepFour(data);
        }
        else {
            steps(3);
            createTable();
            $('#ez-back-link').off('click').on('click', goToStepTwo);
            if (pageParams.idColumn === true && pageParams.message) {
                elem.show().html(pageParams.message).addClass('alert-warning');
            }
            else if (pageParams.message) {
                elem.show().html(pageParams.message).addClass('alert-warning');
            }
        }
    }
    var backToStepThree = function () {
        steps(3);
        $('#ez-back-link').off('click').on('click', goToStepTwo);
    };
    // eslint-disable-next-line consistent-return
    var goToStepFour = function (data) {
        $('#message').hide();
        $('#hasDefaultValue').hide();
        var template = $.ezdia.template.get('upload-excel-review-table');
        var container = $("#" + containerSuffix + "4");
        steps(4);
        container.empty().html(data);
        pageParams = $.ezdia.config.pageParams;
        if (pageParams.redirectToCreateImportView === false &&
            pageParams.message &&
            pageParams.message.success) {
            var elem = $('#message');
            steps(1);
            elem.show().html(pageParams.message.message).addClass('alert-danger');
            intilizePageParams();
        }
        else {
            $('#ez-back-link').off('click').on('click', clearSubmitRowData);
            container.append(template(pageParams));
            if (pageParams.badRowNums) {
                return false;
            }
            if (pageParams.data) {
                createReviewGrid();
                if (pageParams.hasDefaultValue === 'true') {
                    $('#hasDefaultValue').html('* One or more fileds marked * will be added as a default value.');
                    $('#hasDefaultValue').show();
                }
                if (pageParams.choiceColumnUnmachedMessage !== undefined ||
                    pageParams.choiceColumnUnmachedMessage !== null) {
                    var elem = $('#message');
                    elem
                        .show()
                        .html(pageParams.choiceColumnUnmachedMessage)
                        .addClass('alert-warning');
                    if (pageParams.contentMessages &&
                        pageParams.contentMessages.success) {
                        elem
                            .show()
                            .html(pageParams.message
                            ? pageParams.message + "<br/>" + pageParams.contentMessages.message
                            : pageParams.message)
                            .addClass('alert-warning');
                    }
                }
                else if (pageParams.redirectToCreateImportView === true &&
                    pageParams.message &&
                    pageParams.message.success) {
                    var elem = $('#message');
                    elem
                        .show()
                        .html(pageParams.message.message)
                        .addClass('alert-warning');
                }
                $('#ez-review-items-next').off('click').on('click', goToStepFive);
            }
            else if (pageParams.message &&
                pageParams.message.success === true &&
                pageParams.message.message) {
                var elem = $('#message');
                elem.show().html(pageParams.message.message);
                steps(1);
                intilizePageParams();
            }
        }
    };
    var goToStepFive = function () {
        $('#message').hide();
        var template = $.ezdia.template.get('upload-excel-confirm');
        var container = $("#" + containerSuffix + "5");
        var items = pageParams.dataCount;
        var context = {
            genericImport: pageParams.genericImport,
            userManagement: pageParams.userManagement,
            import: getFileName(),
            project: getProjectName(),
            items: items + (items > 1 ? ' new items' : ' new item')
        };
        steps(5);
        container.empty().html(template(context));
        $('#ez-toggle-confirm-setting')
            .off('click')
            .on('click', function () {
            $('#import-name-static').hide();
            $('#import-name-dynamic').show();
        });
        $('#ez-save-confirm-setting').off('click').on('click', saveSettings);
        $('#ez-cancel-confirm-setting')
            .off('click')
            .on('click', function () {
            $('#import-name-dynamic').hide();
            $('#import-name-static').show();
        });
        $('#ez-back-link')
            .off('click')
            .on('click', function click() {
            steps(4);
            $(this).off('click').on('click', clearSubmitRowData);
        });
        $('#updateDBBtn').on('click', submitReviewItems);
    };
    var getFileName = function () {
        var name = $.ezdia.config.pageParams.importName;
        return name;
    };
    var getProjectName = function () {
        var name = pageParams.account;
        if (pageParams.allProjects) {
            var projects = ezdia.util.jsonParse(pageParams.allProjects);
            $.each(projects, function (key, accounts) {
                // eslint-disable-next-line consistent-return
                $.each(accounts, function (accName, accLabel) {
                    if (accName === name) {
                        name = accLabel;
                        return false;
                    }
                });
            });
        }
        return name;
    };
    var saveSettings = function () {
        var name = $('#ez-import-settings-name').val();
        if (!name) {
            // eslint-disable-next-line no-alert
            ezdia.alert('Please enter name');
        }
        else {
            $('#ez-import-file-name').html(name);
            $('#ez-setting-save').show();
            $('#import-name-dynamic').hide();
            $('#import-name-static').show();
            $('#ez-toggle-confirm-setting').hide();
        }
    };
    var clearSubmitRowData = function () {
        $.ajax({
            type: 'POST',
            url: "deleteImportData.htm?importDTO.uuidFileName=" + pageParams.uuidFileName,
            success: function () {
                backToStepThree();
            }
        });
    };
    var loadUploadBtnSuccess = function (data) {
        $('#ez-upload-actions').html(data);
        $('#DataUploader').validate({
            rules: {
                accountName: {
                    required: true
                },
                upload: {
                    required: true,
                    extension: 'csv|xls|xlsx'
                }
            },
            messages: {
                accountName: 'Please select your project for which you want to upload bulk data',
                upload: 'Please select a file  .csv, .xls or .xlsx file'
            },
            errorClass: 'validation-error-msg'
        });
        $('#ez-submit-excel').on('click', submitExcel);
    };
    function submitExcel() {
        var frm = $('#DataUploader');
        var btn = $(this);
        if (frm.valid()) {
            btn.button('loading');
        }
        $('#middle_div_excel_response').html('');
        frm
            .ajaxForm({
            success: function (resp) {
                btn.button('reset');
                var obj = {};
                if (resp && resp.error === true && resp.message) {
                    var elem = $('#message');
                    elem.hide();
                    $("#" + containerSuffix + 3).html(resp.message);
                    elem.show().html(resp.message).addClass('alert-warning');
                    steps(2);
                    var btn1 = $(this);
                    loadUploadBtn(btn1);
                    $('#ez-back-link')
                        .off('click')
                        .on('click', function () {
                        $('#message').hide();
                        steps(1);
                    });
                }
                else if (resp &&
                    resp.success === undefined &&
                    !resp.includes('Apologies')) {
                    goToStepThree(resp);
                }
                else if (resp && resp.success === false) {
                    obj = {
                        response: resp.message,
                        success: resp.success,
                        url: ''
                    };
                    successErrorDialog(obj);
                }
                else {
                    obj = {
                        response: resp,
                        success: false,
                        url: ''
                    };
                    successErrorDialog(obj);
                }
            }
        })
            .submit();
    }
    var createTable = function () {
        var template = $.ezdia.template.get('upload-excel-table');
        var content = '';
        var context = getUploadContext();
        var row = (context || {}).row;
        content = template(context);
        $('#ez-upload-excel-table-container').html(content);
        if (row) {
            $('#ez-js-filed-count').html("Total " + row.length + " Fields");
        }
        events();
    };
    var events = function () {
        var select = $('#ez-upload-excel-table-container').find('select[data-type="select"]');
        $.each(mappendFields, function (i, mval) {
            select
                .find("option[value=\"" + mval + "\"]:not(\":selected\")")
                .attr('disabled', 'disabled');
        });
        select.find('[data-onclick=addNewFields]').on('click', function (e) {
            e.preventDefault();
        });
        onchangeSelect(select);
        validate(select);
        $('#ez-submit-column').on('click', function click() {
            dataUploader($(this));
        });
        $('input:checkbox[name$=".importColumn"]').on('click', toggleCheckbox);
        $('#ez-checkbox-unmap-all').on('click', function click() {
            unmap.call(this);
        });
        $('#ez-create-unmap-all').on('click', function click() {
            createAllFields.call(this, select);
        });
    };
    var dataUploader = function (btn) {
        var frm = $('#ez-upload-excel-column');
        var valid = frm.valid();
        if (valid) {
            btn.button('loading');
            frm
                .ajaxForm({
                success: function (resp) {
                    btn.button('reset');
                    var obj = {};
                    if (resp &&
                        ((typeof resp === 'object' && !resp.error) ||
                            (typeof resp !== 'object' && !resp.includes('Apologies')))) {
                        goToStepFour(resp);
                    }
                    else {
                        obj = {
                            response: typeof resp === 'object' ? resp.message : resp,
                            success: false,
                            url: ''
                        };
                        successErrorDialog(obj);
                    }
                }
            })
                .submit();
        }
    };
    var createReviewGrid = function () {
        var grid = $('#grid');
        grid.jqGrid({
            data: pageParams.data,
            datatype: 'json',
            height: 'auto',
            url: "getImportPagingData.htm?importDTO.uuidFileName=" + pageParams.uuidFileName + "&importDTO.totalImportRecords=" + pageParams.totalImportRecords,
            autowidth: true,
            shrinkToFit: false,
            rowNum: 10,
            width: '100%',
            rowList: [10, 20, 30],
            pager: '#footer',
            colNames: pageParams.colNames,
            colModel: pageParams.colModel,
            viewrecords: true,
            records: 20,
            pgtext: 'Page {0} of many',
            recordtext: 'View {0} - {1} of many',
            caption: 'Bulk Upload Data'
        });
        grid.jqGrid('navGrid', '#footer', {
            add: false,
            edit: false,
            del: false,
            search: false
        });
    };
    function submitReviewItems() {
        var btn = $(this);
        var inputs = $('#ez-import-settings-name');
        if (inputs.is(':visible')) {
            var name_1 = inputs.val();
            if (!name_1) {
                // eslint-disable-next-line no-alert
                ezdia.alert('Please enter name');
            }
            else {
                $('#import_name').val(name_1);
            }
        }
        btn.button('loading');
        $('#ez-confirm-bulkupload-form')
            .ajaxForm({
            success: function (resp) {
                btn.button('reset');
                var obj = {};
                if (resp &&
                    resp.success === undefined &&
                    !resp.includes('Apologies')) {
                    successReviewItems(resp);
                }
                else if (resp && resp.success === false) {
                    obj = {
                        response: resp.message,
                        success: resp.success,
                        url: ''
                    };
                    successErrorDialog(obj);
                }
                else {
                    obj = {
                        response: resp,
                        success: false,
                        url: ''
                    };
                    successErrorDialog(obj);
                }
            },
            error: function () {
                btn.button('reset');
                ezdia.util.showSuccessError({
                    message: 'There was an error while executing your request. Please contact support.',
                    error: true,
                    autohide: false
                });
            }
        })
            .submit();
    }
    var cancelReviewItems = function () {
        var wrapper = document.getElementById('ez-cancel-import-message');
        if (!wrapper) {
            var divEl = $('<div>', {
                id: 'ez-cancel-import-message'
            });
            $('body').append(divEl);
        }
        wrapper = $('#ez-cancel-import-message');
        wrapper.html('Are you sure.');
        wrapper.dialog({
            modal: true,
            title: 'Cancel import items',
            width: '350',
            height: '150',
            buttons: {
                No: function () {
                    $(this).dialog('close');
                },
                Yes: function () {
                    $(this).dialog('close');
                    refreshSession();
                }
            }
        });
    };
    var successReviewItems = function (data) {
        var container = $("#" + containerSuffix + "4").empty();
        $('div[data-step-container="container"]').hide();
        container.html(data).show();
        pageParams = $.ezdia.config.pageParams;
        showMessages();
        steps(1);
        intilizePageParams();
    };
    var intilizePageParams = function () {
        $.ezdia.config.pageParams.excelColumn = null;
        $.ezdia.config.pageParams.data = null;
        $.ezdia.config.pageParams.fields = null;
        $.ezdia.config.pageParams.idColumn = null;
        $.ezdia.config.pageParams.idColumnvalue = null;
        $.ezdia.config.pageParams.primaryColumnIndex = null;
        $.ezdia.config.pageParams.importSetting = null;
        $.ezdia.config.pageParams.message = null;
        $.ezdia.config.pageParams.colNames = null;
        $.ezdia.config.pageParams.colModel = null;
        $.ezdia.config.pageParams.totalImportRecords = null;
        $.ezdia.config.pageParams.fileExtension = null;
        $.ezdia.config.pageParams.uuidFileName = null;
        $.ezdia.config.pageParams.bulkFlag = null;
        $.ezdia.config.pageParams.importName = null;
        $.ezdia.config.pageParams.editType = null;
        $.ezdia.config.pageParams.hasDefaultValue = null;
        $.ezdia.config.pageParams.choiceColumnUnmachedMessage = null;
        $.ezdia.config.pageParams.rowsToProcess = null;
        $.ezdia.config.pageParams.formtype = null;
        $.ezdia.config.pageParams.genericImport = null;
        $.ezdia.config.pageParams.userManagement = null;
        $.ezdia.config.pageParams.redirectToCreateImportView = null;
        $.ezdia.config.pageParams.dataCount = null;
        $.ezdia.config.pageParams.projectType = null;
        $.ezdia.config.pageParams.contentMessages = null;
    };
    var showMessages = function () {
        var msg = pageParams.message;
        var elem = $('#message');
        var arr = [];
        var count = 0;
        var txt = '';
        var cls = msg.success ? '' : 'alert-danger';
        $.each(msg, function (i, obj) {
            if (i === 'no_update') {
                txt = "<b>No update!</b> There were no updates done for following rows from Excel file.<br>" + obj;
            }
            else if (i === 'error_rows') {
                txt = "<b>Error!</b> An error occurred while uploading following rows from Excel file.<br>" + obj;
            }
            else if (i === 'success_ids') {
                arr = obj;
                var url = '/desk/MyTask.htm';
                if (pageParams.genericImport || pageParams.account === 'expert') {
                    url = '/desk/ShowStoreForm.htm';
                }
                var link = "'" + pageParams.CONTEXT_ROOT + url + "'";
                var params = "'accountName=" + pageParams.account + "&role=" + pageParams.role + "&id=" + arr + "'";
                if (pageParams.account === 'expert') {
                    params = "'formtype=user_management_" + pageParams.role + "&accountName=" + pageParams.account + "&userManagement=true&id=" + arr + "'";
                }
                if (pageParams.genericImport) {
                    params = "'formtype=" + pageParams.formtype + "&id=" + arr + "'";
                }
                count = arr.split(',').length;
                txt = "<b>Success!</b> " + count + " Item(s) have been successfully imported. Go to <a href=\"javascript:refreshSession(" + link + "," + params + ",'post','_self' )\" >imported</a> items.";
                cls = 'alert-success';
            }
            else {
                txt = obj;
            }
            elem.show().html(txt).addClass(cls);
        });
    };
    var onchangeSelect = function (select) {
        // eslint-disable-next-line consistent-return
        select.selectmenu().on('change', function change() {
            var elem = $(this);
            var index = elem.data('index');
            var label = $("#excelColumnLabel" + index).text() || '';
            var value = this.value;
            var prevValue = elem.data('prevValue');
            if (value === '') {
                elem.closest('tr[data-row="row"]').removeClass(classes.success);
            }
            else if (value === 'addNewFields') {
                elem.val(prevValue);
                $.ezdia.field.create({
                    type: 'import',
                    array: [{ index: index, label: label }],
                    elem: elem,
                    select: select
                });
                return false;
            }
            else if (value !== prevValue) {
                select.find("option[value=\"" + prevValue + "\"]").removeAttr('disabled');
                select
                    .find("option[value=\"" + value + "\"]:not(\":selected\")")
                    .attr('disabled', 'disabled');
                elem.closest('tr[data-row="row"]').addClass(classes.success);
            }
            updateValues(elem, value);
        });
    };
    var updateValues = function (elem, value) {
        var obj = $.ezdia.config.pageParams.fields[value] || {};
        var name = elem.attr('data-index');
        var id = elem.attr('id');
        $("[name=\"importDTO.columnMatcher[" + name + "].configColumn\"]").val(obj.configColumn || '');
        $("[name=\"importDTO.columnMatcher[" + name + "].parentConfig\"]").val(obj.parentConfig || '');
        $("[name=\"importDTO.columnMatcher[" + name + "].newColumnName\"]").val(obj.name || '');
        $("[name=\"importDTO.columnMatcher[" + name + "].columnLabel\"]").val(obj.label || '');
        $("[name=\"importDTO.columnMatcher[" + name + "].editType\"]").val(obj.type || '');
        $("#ez-group-" + id).text(obj.group_name || '');
        elem.data('prevValue', value);
        elem.trigger('blur');
    };
    var validate = function (select) {
        $.ezdia.validate.create({}, 'ez-upload-excel-column', true);
        $.each(select, function each() {
            $(this).rules('add', {
                required: function (el) {
                    var index = $(el).data('index');
                    var checkbox = $("[name=\"importDTO.columnMatcher[" + index + "].importColumn\"]");
                    return checkbox.is(':checked');
                }
            });
        });
    };
    var getUploadContext = function () {
        var importSetting = pageParams.importSetting;
        var excelColumn = pageParams.excelColumn;
        var idColumn = pageParams.idColumn;
        var fields = pageParams.fields;
        var arr = [];
        mappendFields = [];
        $.each(excelColumn, function (i, obj) {
            var importrow = false;
            var label = obj.excelColumnEscaped
                .toLowerCase()
                .trim()
                .replace(/\r?\n|\r/g, '');
            var options = [];
            obj.cls = '';
            if (importSetting) {
                // eslint-disable-next-line consistent-return
                $.each(importSetting, function (j, mobj) {
                    if (mobj.key
                        .toLowerCase()
                        .trim()
                        .replace(/\r?\n|\r/g, '') === label ||
                        mobj.value
                            .toLowerCase()
                            .trim()
                            .replace(/\r?\n|\r/g, '') === label) {
                        label = mobj.value;
                        importrow = true;
                        importSetting.splice(j, 1);
                        return false;
                    }
                });
            }
            else {
                importrow = true;
            }
            $.each(fields, function (j, column) {
                var opt = {
                    label: column.label,
                    value: j
                };
                var lbl = label
                    .toLowerCase()
                    .trim()
                    .replace(/\r?\n|\r/g, '');
                if (importrow &&
                    (lbl ===
                        column.label
                            .toLowerCase()
                            .trim()
                            .replace(/\r?\n|\r/g, '') ||
                        lbl ===
                            column.name
                                .toLowerCase()
                                .trim()
                                .replace(/\r?\n|\r/g, ''))) {
                    obj.cls = classes.success;
                    obj.configColumn = column.configColumn;
                    obj.parentConfig = column.parentConfig;
                    obj.newColumnName = column.name;
                    obj.columnLabel = column.label;
                    obj.editType = column.type;
                    obj.group = column.group_name;
                    obj.value = opt.value;
                    opt.selected = 'selected';
                    obj.mapped = true;
                    mappendFields.push(opt.value);
                }
                options.push(opt);
                obj.options = options;
                obj.importrow =
                    importSetting && !obj.cls && importrow ? false : importrow;
            });
        });
        if (idColumn) {
            var idColumnValue = pageParams.idColumnValue;
            var primaryColumnIndex = pageParams.primaryColumnIndex;
            arr.push({
                idColumn: idColumn,
                configColumn: idColumnValue,
                parentConfig: idColumnValue,
                excelColumn: idColumnValue,
                newColumnName: idColumnValue,
                columnLabel: idColumnValue,
                excelColumnIndex: primaryColumnIndex,
                columnIndex: primaryColumnIndex
            });
            excelColumn = $.merge(arr, excelColumn);
        }
        return {
            row: excelColumn
        };
    };
    var createAllFields = function (select) {
        var tbody = $('#ez-upload-excel-table').find('tbody');
        var rows = tbody
            .find('tr')
            .not("." + classes.success)
            .not("." + classes.danger);
        var arr = [];
        if (!rows.length) {
            // eslint-disable-next-line no-alert
            ezdia.alert('Message', 'All fields are mapped');
            return;
        }
        $.each(rows, function each() {
            var elem = $(this);
            var index = elem.data('index');
            var label = elem.find("#excelColumnLabel" + index).text();
            arr.push({
                index: index,
                label: label
            });
        });
        $.ezdia.field.create({
            type: 'import',
            array: arr,
            select: select
        });
    };
    function unmap() {
        var tbody = $('#ez-upload-excel-table').find('tbody');
        var rows = null;
        var mvalue = this.checked;
        if (mvalue) {
            rows = tbody
                .find('tr')
                .not("." + classes.success)
                .not("." + classes.danger);
        }
        else {
            rows = tbody.find("tr." + classes.danger);
        }
        if (!rows.length) {
            return;
        }
        $.each(rows, function eachrows() {
            var row = $(this);
            var index = row.data('index');
            var checkBox = row.find('input:checkbox[name$=".importColumn"]');
            var mval = null;
            if (!mvalue) {
                mval = row.find("select#columnMatcher" + index).val();
                if (mval) {
                    return;
                }
            }
            checkBox.trigger('click');
        });
    }
    var toggleCheckbox = function (e) {
        var elem = $(e.currentTarget);
        var check = elem.is(':checked');
        var row = elem.closest('tr[data-row="row"]');
        var select = row.find('select[data-type="select"]');
        var selectAll = $('#ez-checkbox-unmap-all');
        if (check) {
            row.removeClass(classes.danger);
            select.removeAttr('disabled');
            if (select.val() !== '') {
                row.addClass(classes.success);
            }
            if (selectAll.is(':checked')) {
                selectAll.prop('checked', false);
            }
        }
        else {
            row.removeClass(classes.success).addClass(classes.danger);
            select.attr('disabled', 'disabled');
            if (select.closest('td[data-row="input"]').hasClass('has-error')) {
                $.ezdia.validate.unhighlight('ez-upload-excel-column', select);
            }
        }
    };
    var getSize = function (obj) {
        var count = 0;
        // tslint:disable-next-line:forin
        for (var i in obj) {
            count = i;
        }
        return +count;
    };
    var getSelect = function (array, label) {
        var select = null;
        // eslint-disable-next-line consistent-return
        $.each(array, function (i, obj) {
            var textbox = $("#ez-new-field-inputs-label" + obj.index);
            var value = textbox.val();
            if (label === value) {
                select = $("#columnMatcher" + obj.index);
                array.splice(i, 1);
                return false;
            }
        });
        return select;
    };
    var onScroll = function () {
        var subHeader = $('#ez-js-sub-heading');
        var placehoderH = $('#ez-js-sub-heading-placeholder');
        var top = subHeader.offset().top;
        var height = subHeader.outerHeight();
        subHeader
            .css({
            top: top
        })
            .addClass('fixed');
        placehoderH.css({
            height: height
        });
    };
    var importObj = {
        load: function () {
            pageParams = $.ezdia.config.pageParams;
            if (pageParams.message &&
                pageParams.message.success &&
                pageParams.genericImport &&
                pageParams.genericImport === true) {
                var elem = $('#message');
                elem.hide();
                elem.show().html(pageParams.message.message).addClass('alert-warning');
            }
            else {
                accountChange();
                roleChange();
                steps(1);
                $('#ez-import-step-btn-next-one').on('click', goToStepTwo);
                $('[data-onclick="add"]')
                    .off('click')
                    .on('click', $.ezdia.field.create);
                $('[name="importDTO.importType"]').on('change', function change() {
                    var value = this.value;
                    var elem = $('#ez-importName');
                    if (value === 'savedimport') {
                        elem.removeAttr('disabled').parent().show();
                    }
                    else {
                        elem.attr('disabled', 'disabled').parent().hide();
                    }
                });
            }
            $('body').on('click', 'a[data-import-btn=cancel]', cancelReviewItems);
            pageLoadingDone();
            onScroll();
        },
        addField: function (data, obj) {
            var fields = $.ezdia.config.pageParams.fields || {};
            $.each(data, function (i, mObj) {
                var len = getSize(fields) + 1;
                fields[len] = mObj;
                var opt = $('<option>', {
                    value: len,
                    text: mObj.label
                });
                var elem = getSelect(obj.array, mObj.label);
                obj.select.append(opt);
                elem.val(len).trigger('change');
            });
            if (obj.array.length) {
                $.each(obj.array, function (i, mObj) {
                    $("#importColumnCheckbox" + mObj.index).trigger('click');
                });
            }
        }
    };
    var pages;
    (function (pages) {
        pages.imports = importObj;
    })(pages = ezdia.pages || (ezdia.pages = {}));
    /*
     ** This $.ezdia is just for old code support
     ** DON'T USE THIS
     */
    $.ezdia.import = importObj;
})(ezdia || (ezdia = {}));
